import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux"

import type { IAppDispatch } from "../store"
import type { IRootState } from "../store/root-reducer"

export const useAppDispatch = () => useDispatch<IAppDispatch>()
export const useAppSelector: TypedUseSelectorHook<IRootState> = useSelector
